<template>
  <div>
    <sign-crypto-withdraw :data="data" />
  </div>
</template>

<script>
import SignCryptoWithdraw from "@/components/Shared/LegalEntity/SignCryptoWithdraw.vue";
import legalService from "@/services/modules/legalService";

export default {
  components: { SignCryptoWithdraw },
  data() {
    return { data: null };
  },
  mounted() {
    const refNum = this.$route.params.id;
    legalService.orderDetails(refNum).then(res => {
      this.data = res.data.data;
    });
  }
};
</script>

<style lang="scss" scoped></style>
